import React from 'react';
import PropTypes from 'prop-types';

// Bootstrap css_class → Tailwind pill classes.
const CLS = {
  primary: 'tw-bg-blue-100 tw-text-blue-700',
  secondary: 'tw-bg-slate-100 tw-text-slate-600',
  success: 'tw-bg-green-100 tw-text-green-700',
  warning: 'tw-bg-amber-100 tw-text-amber-700',
  danger: 'tw-bg-red-100 tw-text-red-700',
  info: 'tw-bg-cyan-100 tw-text-cyan-700',
  dark: 'tw-bg-slate-200 tw-text-slate-800',
};

const BookingStatusBadge = ({ value, data }) => (
  <span className={`tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-xl tw-text-xs tw-font-medium ${CLS[data?.status?.css_class] || CLS.secondary}`}>
    {value}
  </span>
);

BookingStatusBadge.propTypes = {
  value: PropTypes.node,
  data: PropTypes.shape({
    status: PropTypes.shape({
      css_class: PropTypes.string
    })
  })
};

export default BookingStatusBadge;
